import React from "react";
import styled from "@emotion/styled";
import Shared02Headings from "../../guestsharedcomponents/Shared02Headings/Shared02Headings";

const ContainerSection = styled.section`
  .cta-img {
    max-width: 50rem;
    margin: 0 auto -8rem auto;
    height: 50rem;

    img {
      object-position: top;
    }
  }
`;

const G09ConversionCTA = () => {
  return (
    <ContainerSection className="t-ptb-10 t-overflow-x-hidden">
      <div className="t-container">
        <div className="cta-img">
          <img
            src="https://res.cloudinary.com/djiqf3usa/image/upload/v1768603035/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/luis-and-tay-sensual-bachata-online-instructors-hero_enmpdq.webp"
            alt=""
          />
        </div>
        <Shared02Headings
          options={{
            style_render: "992",
            main_container_css: "",
            container_mobile_styles: {
              "max-width": "100rem",
              margin: "0 auto",
            },
            container_desktop_styles: {},
            obj_heading: {
              main_text:
                "<span class='t-d-block'>Start <span class='t-enlace'>Learning Bachata </span></span> With Confidence.",
              main_tag_version: "h2",
              main_text_css: "t-h-1",
              heading_mobile_styles: {
                "text-align": "center",
                color: "#fff",
                "font-weight": "900",
                "margin-bottom": "1rem",
                "text-shadow":
                  "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
              },
              heading_desktop_styles: {},
            },
            obj_support_heading: {
              main_text:
                "Join LT Mastery and train inside a structured online academy designed to help you grow step by step. Learn with clarity, progress with intention, and feel the difference in your dancing on and off the floor",
              main_tag_version: "p",
              main_text_css: "",
              heading_mobile_styles: {
                "text-align": "center",
                color: "#fff",
                "font-weight": "400",
                "margin-bottom": "1.5rem",
                "text-shadow":
                  "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
              },
              heading_desktop_styles: {},
            },

            obj_divider: {
              divider_mobile_styles: {
                width: "70%",
                background:
                  "linear-gradient(90deg, transparent, #e6c28b, transparent)",
                margin: "0 auto 5rem auto",
              },
              divider_desktop_styles: {},
            },
            obj_paragraph: false,
            obj_buttons: {
              main_objinfo: {
                icon_left: false,
                icon_right: false,
                main_btn_heading: "Start Learning Today",
                main_btn_link: "https://members.ltmastery.com/",
                main_btn_container_classes: "t-btn-principal-1 t-mb-1 t-mr-1",
                main_btn_classes: "t-uppercase t-font-1-4",
                main_btn_version: "external_link_button", //main_button, internal_link_button, external_link_button
                main_btn_loader: false,
                main_handleClick: false,
              },
              secundary_objinfo: false,
              btn_main_container_classes: "t-flex-jsc t-flex-wrap",
            },
            heading_version: "heading_01",
          }}
        />
      </div>
    </ContainerSection>
  );
};

export default G09ConversionCTA;
